import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import injectSagas from 'helpers/injectSagas'
import CSSModules from 'helpers/CSSModulesUtil'
import Dialog from 'react-toolbox/lib/dialog'
import { userURL } from 'config'

import NvbugsDialogContent from './NvbugsDialogContent'

import {
  postNvbugProject, updatePage, clear, fetchNvbug
} from './actions'

import NvbugsDialogSaga from './sagas'
import { NVBUGS_DIALOG } from './constants'
import { nvbugsIdSelector, pageSelector, selectedProjectSelector } from './selectors'
import styles from './styles.scss'
import UploadProgress from './UploadProgress'
import FontIcon from 'react-toolbox/lib/font_icon'
import { getQueryVariable, removeQueryParam } from 'helpers/Utils'

const mapStateToProps = (state) => {
  return {
    page: pageSelector(state),
    nvbugId: nvbugsIdSelector(state),
    selectedProject: selectedProjectSelector(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchNvbug: (nvbugId) => dispatch(fetchNvbug(nvbugId)),
    updatePage: (page) => dispatch(updatePage(page)),
    onSave: (nvbugId, projectId) => dispatch(postNvbugProject(nvbugId, projectId)),
    clear: () => dispatch(clear())
  }
}

class NvbugsDialog extends Component {
  onCancel = () => {
    this.props.updatePage(1)
    this.props.clear()
    removeQueryParam('nvbug')
  }

  onSave = (nvbugId, projectId) => {
    this.props.onSave(nvbugId, projectId)
    this.props.updatePage(2)
  }

  onOpenApproveRevisions = (projectId) => {
    const url = new URL(`project/${projectId}/view?action=nvqual_approval`, userURL)
    window.open(url, `_blank`).focus()
    this.onCancel()
  }

  componentWillUnmount() {
    this.props.clear()
  }

  componentDidMount() {
    const { fetchNvbug }= this.props
    const queryString = getQueryVariable("nvbug")
    if (queryString) {
      fetchNvbug(queryString)
    }
  }

  getActions = () => {
    const { 
      page, 
      nvbugId,
      selectedProject
   } = this.props 
    switch(page) {
      case 1:
        return [
          { label: 'Submit', onClick: this.onSave.bind(this, nvbugId, selectedProject), disabled: selectedProject == null },
          { label: 'Cancel', onClick: this.onCancel },
        ]
      case 2:
        return [
          { label: 'Submit', disabled: true },
          { label: 'Cancel', disabled: true },
        ]
      case 3:
        return [
          { label: 'See Project\'s NVQual Revisions', onClick: () => this.onOpenApproveRevisions(selectedProject) },
          { label: 'Close', onClick: this.onCancel }
        ]
      case 4:
        return [
          { label: 'Close', onClick: this.onCancel }
        ]
      default:
        return []
    }
  }

  getTitle = () => {
    const{ page, selectedProject, nvbugId } = this.props
    switch(page) {
      case 1:
        return `Associate NVBug #${nvbugId}`
      case 2:
        return `Associating Project #${selectedProject}`
      case 3:
        return `Association Completed - Project #${selectedProject}`
      case 4:
        return `Association Failed`
      default:
        return ``
    }
  }

  getOnSuccessMessage = () => {
    const { selectedProject, nvbugId } = this.props
    return (
      <div className={styles.successMessage}>
        <FontIcon
          className={styles.success}
          value="check_circle"
        />        
        <div className={styles.messageText}>Project #{selectedProject} has been successfully linked with NVBug #{nvbugId}. <br/>If the associated NVBug has any NVQual reviews, you may view the full NVQual report via the following button.</div>
      </div>
    )
  }

  getOnFailedMessage = () => {
    const { selectedProject, nvbugId } = this.props
    return (
      <div className={styles.failedMessage}>        
      <FontIcon
        className={styles.failed}
        value="error"
      />      
      <div className={styles.messageText}>There was an error when linking Project #{selectedProject} with NVBug #{nvbugId}. Please try again.</div>
    </div>
    )
  }

  render() {
    const {
      page,
      active,
      nvbugId
    } = this.props

    return (
        <Dialog
          actions={this.getActions()}
          active={nvbugId !== ''}
          title={this.getTitle()}
          onOverlayClick={this.onCancel}
          onEscKeyDown={this.onCancel}
          theme={styles}
        > 
          {page === 1 && <NvbugsDialogContent />}
          {page === 2 && <UploadProgress />}
          {page === 3 && this.getOnSuccessMessage()}
          {page === 4 && this.getOnFailedMessage()}
        </Dialog>
    )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withSagas = injectSagas({ [NVBUGS_DIALOG]: NvbugsDialogSaga })
const withStyle = CSSModules(styles)

export default compose(
  withSagas,
  withConnect,
  withStyle,
)(NvbugsDialog)
